"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefiPassportClaimerFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var DefiPassportClaimerFactory = /** @class */ (function (_super) {
    __extends(DefiPassportClaimerFactory, _super);
    function DefiPassportClaimerFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    DefiPassportClaimerFactory.prototype.deploy = function (_creditScoreContract, _defiPassportContract, overrides) {
        return _super.prototype.deploy.call(this, _creditScoreContract, _defiPassportContract, overrides || {});
    };
    DefiPassportClaimerFactory.prototype.getDeployTransaction = function (_creditScoreContract, _defiPassportContract, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _creditScoreContract, _defiPassportContract, overrides || {});
    };
    DefiPassportClaimerFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    DefiPassportClaimerFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    DefiPassportClaimerFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return DefiPassportClaimerFactory;
}(contracts_1.ContractFactory));
exports.DefiPassportClaimerFactory = DefiPassportClaimerFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_creditScoreContract",
                type: "address",
            },
            {
                internalType: "address",
                name: "_defiPassportContract",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newContractAddress",
                type: "address",
            },
        ],
        name: "CreditScoreContractSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newDefiPassportContract",
                type: "address",
            },
        ],
        name: "DefiPassportContractSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
            {
                internalType: "address",
                name: "_passportSkin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_skinId",
                type: "uint256",
            },
        ],
        name: "claimPassport",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "creditScoreContract",
        outputs: [
            {
                internalType: "contract ISapphireCreditScore",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "defiPassport",
        outputs: [
            {
                internalType: "contract IDefiPassport",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_creditScoreContract",
                type: "address",
            },
        ],
        name: "setCreditScoreContract",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=DefiPassportClaimerFactory.js.map